export const ACTION_CODE = 'SUBSIDIARY' + '_ACTION';
